package one.healthium.cali.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.cali.presentation.feature.today.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}